/**
 * PROTEF-5655: las horas de recogida/devolucion deben respetar el calendario
 * de la sucursal (GET /v1/frame/branch/reserve/schedule).
 *
 * Requiere en el componente: this.filter (pickLocation, pickDate,
 * returnLocation, returnDate) y el getter this.filters
 * ("configuration/getFilters"). Si el endpoint falla o no devuelve horas,
 * se mantiene el comportamiento anterior (horas de la configuracion).
 */
export default {
  data: () => ({
    lastBranchScheduleParams: null,
  }),
  computed: {
    branchSchedule() {
      return this.$store.getters["branchVehicle/branchSchedule"];
    },
    pickUpAvailableHours() {
      const schedule = this.branchSchedule;
      if (schedule && schedule.pickUpHours && schedule.pickUpHours.length) {
        return schedule.pickUpHours;
      }
      return this.filters && this.filters.hours ? this.filters.hours : null;
    },
    returnAvailableHours() {
      const schedule = this.branchSchedule;
      if (schedule && schedule.returnHours && schedule.returnHours.length) {
        return schedule.returnHours;
      }
      if (this.filters && this.filters.hoursReturn) {
        return this.filters.hoursReturn;
      }
      return this.filters && this.filters.hours ? this.filters.hours : null;
    },
  },
  watch: {
    "filter.pickLocation": "refreshBranchSchedule",
    "filter.pickDate": "refreshBranchSchedule",
    "filter.returnLocation": "refreshBranchSchedule",
    "filter.returnDate": "refreshBranchSchedule",
  },
  methods: {
    branchScheduleDateToMillis(date) {
      // date llega como "YYYY-MM-DD"; se envia mediodia local para evitar
      // saltos de dia por zona horaria (el backend resuelve el dia).
      return new Date(`${date}T12:00:00`).getTime();
    },
    refreshBranchSchedule() {
      const pickUpBranch =
        this.filter && this.filter.pickLocation
          ? this.filter.pickLocation.id
          : null;
      if (!pickUpBranch || !this.filter.pickDate) {
        this.lastBranchScheduleParams = null;
        this.$store.dispatch("branchVehicle/clearBranchSchedule");
        return;
      }
      const params = {
        pickUpBranch,
        pickUpDate: this.branchScheduleDateToMillis(this.filter.pickDate),
      };
      // returnBranch exige returnDate (BadRequestException si falta)
      const returnBranch =
        this.filter.returnLocation && this.filter.returnLocation.id
          ? this.filter.returnLocation.id
          : pickUpBranch;
      if (this.filter.returnDate) {
        params.returnBranch = returnBranch;
        params.returnDate = this.branchScheduleDateToMillis(
          this.filter.returnDate
        );
      }
      const serialized = JSON.stringify(params);
      if (serialized === this.lastBranchScheduleParams) {
        return;
      }
      this.lastBranchScheduleParams = serialized;
      this.$store
        .dispatch("branchVehicle/getBranchReserveSchedule", params)
        .catch(() => {
          // fallback silencioso: los computed vuelven a filters.hours
        });
    },
  },
};
